import Mmenu from 'mmenu-js';

export class mmenuStarter {
	
		constructor() {

			const menu = new Mmenu( '#menu', {
				extensions: [
					 "position-right"
				 ],
				 keyboardNavigation: {
					 enable: true,
					 enhance: true,
				 }

			});

			const icon = document.getElementById('mmenu-hamburger');
			const API = menu.API;

			icon.addEventListener('click', function() {
				if (document.querySelector('body').classList.contains('mm-wrapper_opened')) {
					API.close();
				} else {
					API.open();
				}
			})


			API.bind( "open:finish", function() {
				setTimeout(function() {
				  icon.classList.add( "is-active" );
				}, 0);
			 });
			 API.bind( "close:finish", function() {
				setTimeout(function() {
				   icon.classList.remove( "is-active" );
				}, 0);
			 });

		}
	
}
